import { Clickable } from '@ahmdigital/ui';
import Icon from '@ahmdigital/icons-web';
import styled, { css } from 'styled-components';

import { PREMIUM_REVIEW_TOGGLE_STYLE, PremiumReviewToggleStyleType } from '../../ahm-constants/ui';

type PropsWithType = {
  type?: PremiumReviewToggleStyleType;
  hasMargin?: boolean;
};

type WrapperProps = PropsWithType & {
  isAlternativePage: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  line-height: 2.3rem;

  ${({ type }) =>
    type === PREMIUM_REVIEW_TOGGLE_STYLE.FLAT &&
    css`
      background-color: ${({ theme }) => theme.colors.grey70};
      color: ${({ theme }) => theme.colors.white};
      font-size: 1rem;
      padding: 1rem 1.5rem;
      justify-content: center;

      label * {
        color: white !important;
      }

      @media (max-width: ${({ theme }) => theme.media.sm}) {
        width: 100%;
      }
    `}

  ${({ type }) =>
    type === PREMIUM_REVIEW_TOGGLE_STYLE.RIBBON &&
    css`
      background-color: ${({ theme }) => theme.colors.grey30};
      color: ${({ theme }) => theme.colors.black};
      font-size: 0.875rem;
      margin: 1.25rem 0 0.625rem;
      margin-left: -12%;
      padding: 0.625rem 0.25rem;
      position: relative;
      text-align: center;
      width: 124%;

      &::before,
      &::after {
        bottom: -0.625rem;
        content: '';
        height: 0;
        position: absolute;
        width: 0;
      }

      &::before {
        border-left: 0.625rem solid transparent;
        border-top: 0.625rem solid ${({ theme }) => theme.colors.grey40};
        left: 0;
      }

      &::after {
        border-right: 0.625rem solid transparent;
        border-top: 0.625rem solid ${({ theme }) => theme.colors.grey40};
        right: 0;
      }
    `}

    ${({ type }) =>
    type === PREMIUM_REVIEW_TOGGLE_STYLE.READ_ONLY &&
    css`
      font-weight: ${({ theme }) => theme.fontWeights.bold};
    `}

    ${({ isAlternativePage }) =>
    isAlternativePage &&
    css`
      width: 100%;
      justify-content: center;
      text-align: left;
    `}

    ${({ type }) =>
    type === PREMIUM_REVIEW_TOGGLE_STYLE.FLAT_WHITE &&
    css`
      background-color: ${({ theme }) => theme.colors.white};
      border-bottom: 1px solid ${({ theme }) => theme.colors.black};
      border-top: 1px solid ${({ theme }) => theme.colors.black};
      padding: 1rem 1.5rem;
      justify-content: center;
    `}
`;

export const StyledIcon = styled(Icon)`
  display: flex;
  justify-self: center;
  position: relative;
  bottom: 2px;

  ${({ type }) =>
    type === PREMIUM_REVIEW_TOGGLE_STYLE.RIBBON &&
    css`
      font-size: 16px;
    `}
`;

export const HelpLink = styled(Clickable)`
  display: inline;
  width: 24px;
`;
